export const RESET_SORT_MENU = 'RESET_SORT_MENU';
export const SHOW_SORT_MENU = 'SHOW_SORT_MENU';
export const HIDE_SORT_MENU = 'HIDE_SORT_MENU';
export const SHOW_ORG_SELECT = 'SHOW_ORG_SELECT';
export const SHOW_JIT_ORG_SELECT = 'SHOW_JIT_ORG_SELECT';
export const SHOW_BULL_PHISH_ORG_SELECT = 'SHOW_BULL_PHISH_ORG_SELECT';
export const SORTING_SELECT_ENABLED = 'SORTING_SELECT_ENABLED';
export const SORTING_VIEWCHANGE_ENABLED = 'SORTING_VIEWCHANGE_ENABLED';
export const SORTING_FILTERS_ENABLED = 'SORTING_FILTERS_ENABLED';
export const SORTING_ORDERBY_ENABLED = 'SORTING_ORDERBY_ENABLED';
export const CHANGE_VIEW_TYPE = 'CHANGE_VIEW_TYPE';
export const CHANGE_ORDERBY_TYPE = 'CHANGE_ORDERBY_TYPE';
export const SET_ORDERBY_TYPES = 'SET_ORDERBY_TYPES';
export const SET_SELECT_TYPES = 'SET_SELECT_TYPES';
export const CHANGE_SELECT_TYPE = 'CHANGE_SELECT_TYPE';
export const SORTING_ENABLED_OPTIONS = 'SORTING_ENABLED_OPTIONS';
export const ADD_ACTIVE_FILTER = 'ADD_ACTIVE_FILTER';
export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS';
export const REMOVE_ACTIVE_FILTER = 'REMOVE_ACTIVE_FILTER';
export const CLEAR_ACTIVE_FILTERS = 'CLEAR_ACTIVE_FILTERS';
export const SET_ORDER_BY_DIRECTION = 'SET_ORDER_BY_DIRECTION';
export const SET_ORDER_BY_PROPERTY = 'SET_ORDER_BY_PROPERTY';
export const SET_ACTION_MENU = 'SET_ACTION_MENU';
